import { useMutation, useQuery } from "react-query";
import { getDropoffDetail, updateDropoff } from "../../api/ship";
import { useNavigate, useParams } from "react-router";
import { Button, Input, Skeleton } from "antd";
import { BiChevronLeft, BiCopy } from "react-icons/bi";
import { format } from "date-fns";
import { useState } from "react";
import { showErrorToast, showSuccessToast } from "../../utils/toast";

const STATUS = [
  { label: "Pending", value: "pending" },
  { label: "Shpped", value: "shipped" },
  { label: "In Transit", value: "in_transit" },
  { label: "Delivered", value: "delivered" },
  { label: "Need Attention", value: "need_attention" },
  { label: "Awaiting Payment", value: "awaiting_payment" },
  { label: "Canceled", value: "cancel" },
];

const DropoffDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [deliveryFee, setDeliveryFee] = useState("");

  const { data, isLoading } = useQuery(["drop-off-detail", id], () =>
    getDropoffDetail(id)
  );

  const mutation = useMutation(updateDropoff, {
    onSuccess: () => {
      showSuccessToast("Record updated successfully");
    },
    onError: (e) => showErrorToast(e.message),
  });

  const onFinish = () => {
    mutation.mutate({ status, deliveryFee, id: data?._id });
  };

  return (
    <div className="p-5 font-dmsans">
      {isLoading ? (
        <div className="flex flex-col gap-5">
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      ) : (
        <div className="flex flex-col gap-5 mb-16">
          <div className="flex items-center gap-3">
            <BiChevronLeft
              className="text-[#070E05] text-[25px] cursor-pointer"
              onClick={(e) => navigate(`/shipping`)}
            />
            <div className=" font-Neurial font-bold text-[20px] text-[#070E05]">
              Shipping details
            </div>
          </div>
          <div className="w-full flex gap-4">
            <div className="w-7/12 bg-white rounded-lg p-4 flex flex-col gap-4">
              <div className="font-bold text-[17px] font-Neurial flex items-center gap-4">
                <div>
                  Tracking ID{" "}
                  <span className="text-[#2121F1] truncate break-words">
                    #{data?._id || data?.id}
                  </span>
                </div>
                <BiCopy size={25} />
              </div>

              <div className="flex flex-col gap-6">
                <div className="flex justify-between">
                  <p>Courier</p>
                  <p>{data?.courier}</p>
                </div>
                <div className="flex justify-between">
                  <p>Content</p>
                  <p>{data?.description}</p>
                </div>
                <div className="flex justify-between">
                  <p>Tracking Number</p>
                  <p>{data?.trackingNumber}</p>
                </div>
                <div className="flex justify-between">
                  <p>Receipt</p>
                  {data?.file ? (
                    <img src={data?.file} className="h-[100px] w-[100px]" />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex justify-between">
                  <p>Order Created</p>
                  <p>{new Date(data.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="flex justify-between">
                  <p>Order Time</p>
                  <p>{format(new Date(data.createdAt), "h:mmaaa")}</p>
                </div>
              </div>
            </div>
            <div className="w-7/12 flex flex-col gap-4">
              <div className="flex flex-col gap-6 bg-white rounded-lg p-4">
                <div className="flex justify-between">
                  <p>Shipment status</p>
                  <select
                    onChange={(val) => {
                      setStatus(val.target.value);
                    }}
                    value={data?.status}
                    className="border-[1px] border-black rounded-lg p-2"
                  >
                    {STATUS.map((st) => (
                      <option value={st.value}>{st.label}</option>
                    ))}
                  </select>
                </div>
                <div className="flex justify-between">
                  <p>Delivery cost</p>
                  <div className="w-[90px]">
                    <Input
                      onChange={(e) => setDeliveryFee(e.target.value)}
                      min={0}
                      type="number"
                      placeholder="Enter delivery fee"
                      defaultValue={data?.deliveryFee}
                    />
                  </div>
                </div>
                <div className="flex justify-between">
                  <p>Payment status</p>
                  <p>{data?.isPaid ? "Paid" : "Not Paid"}</p>
                </div>

                <Button type="primary" loading={mutation.isLoading} onClick={onFinish}>
                  Update Record
                </Button>
              </div>

              {/* <div className="flex flex-col gap-6 bg-white rounded-lg p-4">
                    <p className="font-bold text-lg">Customer Details</p>
                    <div className="flex justify-between">
                      <p>Customer Name</p>
                      <p>{data?.receiver?.name}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Email</p>
                      <p>{data?.receiver?.email}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Phone Number</p>
                      <p>{data?.receiver?.phoneNumber}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Location/Address</p>
                      <p>{data?.receiver?.pickupLocation}</p>
                    </div>
                  </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropoffDetails;
